<template>
  <v-card class=" app-chat position-relative overflow-hidden text-sm">
    <!-- Navigation Drawer: Active Chat -->
    <div
      class="chat-content-area h-full d-flex flex-column"
      style="height:100%"
    >
      <div
        class="d-flex align-center justify-space-between px-5 py-4"
        style="height: 72px"
      >
        <div class="d-flex align-center">
          <v-btn
            icon
            class="me-2 d-inline-block d-md-none"
          >
            <v-icon>
              {{ icons.mdiMenu }}
            </v-icon>
          </v-btn>

          <v-avatar
            v-if="solicitanteNome"
            size="38"
            class="cursor-pointer"
            :class="`v-avatar-light-bg `"
          >
            <span>{{ solicitanteNome.toUpperCase().substr(0, 1) }}</span>
          </v-avatar>

          <v-avatar
            v-else
            size="38"
            class="cursor-pointer"
            :class="`v-avatar-light-bg `"
          />

          <div class="d-flex flex-column">
            <p class="mb-0 text--primary font-weight-medium mx-2">
              {{ solicitanteNome }}
            </p>

            <span class="text--disabled text-xs mx-2">{{ solicitanteEmail }}</span>
          </div>
        </div>
      </div>

      <v-divider></v-divider>

      <chat-log
        :mensagens="mensagens"
        :solicitante-nome="solicitanteNome"
        :request-error="requestError"
        :pode-responder-mensagem="false"
        :ticket-esta-finalizado="ticketEstaFinalizado"
      />
    </div>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref, watch } from '@vue/composition-api'
import { mdiAttachment, mdiMenu, mdiShare, mdiContentSave, mdiDotsVertical } from '@mdi/js'
import ChatLog from '../ticket-tab/mensagens/ChatLog.vue'

export default {
  components: {
    ChatLog,
  },

  props: {
    solicitanteNome: {
      type: String,
      required: true,
    },
    solicitanteEmail: {
      type: String,
      default: null,
    },
    ticketId: {
      type: Number,
      default: 0,
    },
    mensagens: {
      type: Array,
      default: () => [],
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const respostaTicket = ref({
      idTicket: '',
      resposta: '',
      anexos: [],
    })
    const listaDeAnexos = ref([])

    function adicionarListaDeAnexosARespostaDoTicket() {
      respostaTicket.value.anexos = listaDeAnexos.value.map(anexo => ({
        nome: anexo.nome,
        dataUrl: anexo.dataUrl,
      }))
    }
    watch(() => listaDeAnexos.value, adicionarListaDeAnexosARespostaDoTicket)

    function handleAnexoUpload(event) {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const dataUrl = reader.result
        if (listaDeAnexos.value.length < 6) {
          listaDeAnexos.value.push({
            nome: file.name,
            dataUrl,
            lastModified: file.lastModified,
          })
        } else {
          Vue.$toast.warning('Maximo de 6 anexos')
        }
      }
      adicionarListaDeAnexosARespostaDoTicket()
    }

    const loading = ref(false)
    const requestError = ref(false)
    const chatInputMessage = ref('')

    return {
      respostaTicket,
      listaDeAnexos,
      adicionarListaDeAnexosARespostaDoTicket,
      handleAnexoUpload,
      loading,
      requestError,
      chatInputMessage,
      icons: {
        mdiAttachment,
        mdiMenu,
        mdiShare,
        mdiContentSave,
        mdiDotsVertical,
      },
    }
  },
}
</script>
